import { createSlice } from "@reduxjs/toolkit";

export enum TypeNotification {
  TRANSFER,
  DEPOSIT,
  WITHDRAWAL,
  IDENTIFICATION,
  PROMO,
}

export type NotificationType = {
  type: TypeNotification;
  title: string;
  text: string;
  amount: number;
  currency: string;
  date: string;
  isRead: boolean;
};

type NotificationState = {
  notificationList: NotificationType[] | [];
  isReadList: boolean;
  isCollapsed: boolean;
};

const initialState: NotificationState = {
  notificationList: [],
  isReadList: true,
  isCollapsed: true,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    read(state) {
      if (state.notificationList) {
        state.notificationList.map(
          // eslint-disable-next-line no-return-assign, no-param-reassign
          (notification) => (notification.isRead = true),
        );
        state.isReadList = true;
      }
    },
    readList(state) {
      if (state.notificationList.length) {
        // eslint-disable-next-line array-callback-return
        state.notificationList.find((notification) => {
          if (notification.isRead === false) {
            state.isReadList = false;
          }
        });
      }
    },
    collapse(state) {
      state.isCollapsed = !state.isCollapsed;
    },
  },
});

export const { read, collapse, readList } = notificationSlice.actions;

export default notificationSlice.reducer;
